import camelcaseKeys from 'camelcase-keys'
import qs from 'qs'
import { isNil, join, mapObjIndexed, pipe, reject, values } from 'ramda'
import snakeCaseKeys from 'snakecase-keys'

type ParamKey = string
type ParamValue = string | number | boolean | undefined

export type Params = Record<ParamKey, ParamValue>

export const getQueryString = (params: Params): string => {
  const mapKeyVal = mapObjIndexed<ParamValue, string, string>(
    (val, param, _obj) => `${param}=${val}`
  )

  const mapParams: (x: Params) => string = pipe(
    reject(isNil),
    mapKeyVal,
    values,
    join('&')
  )

  const alreadySnakeCasedKeys = Object.keys(params)
    .filter((k) => !!k)
    .filter((k) => k.includes('_'))

  return mapParams(snakeCaseKeys(params, { exclude: alreadySnakeCasedKeys }))
}

export const parseQueryString = (search: string) =>
  camelcaseKeys(qs.parse(search, { ignoreQueryPrefix: true })) as Record<
    string,
    string
  >

/**
 * Safely parse an URL and retrieve `offset` param as number.
 */
export const getOffsetFromUrl = (
  url: string | undefined
): number | undefined => {
  if (!url) return undefined

  const urlParts = url.split('?')

  if (urlParts.length < 2) return undefined

  const params = qs.parse(urlParts[1])
  const { offset } = params

  if (!offset) return undefined

  return Number(offset)
}
